import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { AssigTripsService } from "../../assigned-trips/assigntrips-service/assigntrips-service";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { takeUntil } from "rxjs/operators";
import { ControlPosition, MapTypeControlOptions } from "@agm/core";
import { sweetAlert } from "src/app/utils/swal";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { FarmoutService } from "src/app/service/farmout-service/farmout.service";
import * as moment from 'moment-timezone';
import { AuthService } from "src/app/service/auth-service/auth.service";

@Component({
  selector: "app-uber-trip-modal",
  templateUrl: "./uber-trip-modal.component.html",
  styleUrls: ["./uber-trip-modal.component.css"],
})
export class UberTripModalComponent implements OnInit, OnDestroy {
  @Input() data;
  @Output() onClose = new EventEmitter<any>();
  uberDetail;
  driverTip;
  uberReceipt;
  isDrawRoute = true;
  origin = { lat: 0.00000, lng: 0.00000 };
  destination = { lat: 0.00000, lng: 0.00000 };
  pickupURL = null;
  dropOffURL = null;

  mapTypeControlOptions: MapTypeControlOptions = {
    position: ControlPosition.TOP_LEFT
  };
  driverLocation;
  user;

  constructor(
    private authService: AuthService, private sharedDataService: SharedDataService, private farmoutService: FarmoutService
) {}


  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          this.details();
        }
      });
  }

  closeDetailModal(evt) {
    this.onClose.emit(evt);
  }

  details() {
    const companyId = this.user.company ? this.user.company._id : this.user._id

    console.log("Assign Data", this.data);
    this.farmoutService
      .rideDetailsRequest({...this.data.uber, company:companyId})
      .subscribe(async (data) => {
        if (data) {
          this.uberDetail = data;
          this.origin = {
            lat: this.uberDetail.pickup.latitude,
            lng: this.uberDetail.pickup.longitude
          };
          this.destination = {
            lat: this.uberDetail.destination.latitude,
            lng: this.uberDetail.destination.longitude
          };
          if(this.uberDetail.waypoints && this.uberDetail.waypoints.length > 0) {
          this.pickupURL = await this.loadStaticMap(this.uberDetail.waypoints[0].latitude, this.uberDetail.waypoints[0].longitude);
          this.dropOffURL = await this.loadStaticMap(this.uberDetail.waypoints[1].latitude, this.uberDetail.waypoints[1].longitude);
          }
          if (this.uberDetail.location) {
            this.driverLocation = {
              latitude: this.uberDetail.location.latitude,
              longitude: this.uberDetail.location.longitude
            }
          } else if (this.uberDetail.trip_end_location) {
            this.driverLocation = {
              latitude: this.uberDetail.trip_end_location.latitude,
              longitude: this.uberDetail.trip_end_location.longitude
            }
          }
        }
      }, err => {
        sweetAlert('Error', err,'warning', 'OK');
      });
    // this.assignTripService
    //   .uberRideReceiptRequest(this.data.uber)
    //   .subscribe((data) => {
    //     if (data) {
    //       console.log("Uber Receipt Data", data);
    //     }
    //   });
  }

  sendTip() {
    if (!this.driverTip) return;
    const companyId = this.user.company ? this.user.company._id : this.user._id

    const payload = {
      "request_id": this.uberDetail.request_id,
      "tip_amount": this.driverTip,
      "company" : companyId
    }
    this.farmoutService
      .tipRequest(payload)
    .subscribe(data => {
      if (data) {
        this.uberDetail.can_tip = false;
        this.details();
      }
    }, err => {
      console.log(err);
      sweetAlert('Error', err,'warning', 'OK');
    });

  }

  getReceipt() {
    const companyId = this.user.company ? this.user.company._id : this.user._id
    this.farmoutService
      .rideReceiptRequest(this.uberDetail.request_id, {company:companyId})
      .subscribe(data => {
        if (data) {
          this.uberReceipt = data;
        }
      }, err => {
        console.log(err);
        sweetAlert('Error', err,'warning', 'OK');
      });
  }

  convertTime(time) {
    if (!time) return 'N/A';
    return moment(time).tz(this.user.timeZone).format("MM/DD/YY HHmm")
  }

  loadStaticMap = async (lat, lng) => {
    let mapKey = '';
    const res = await this.authService.getGoogleKeys().toPromise();
    if (res && res.key) {
      console.log('Load static map API key:');
      mapKey = res.key;
    } else {
      console.error('Error load static map API key');
    }
    let url = 'https://maps.googleapis.com/maps/api/staticmap?center='
      + lat + ',' + lng + '&zoom=18&size=500x500&maptype=satellite&markers=color:red|' + lat
      + ',' + lng + '&key=' + mapKey;

    return url;
  }

  ngOnDestroy(): void {
  }
}
